// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__17-XH","approved":"Status_approved__1yG63","rejected":"Status_rejected__3sh7g","expired":"Status_expired__2ohKo","label":"Status_label__3ehXP"};